<template>
  <article class="tb-ticket-card" :class="{ 'tb-ticket-card--open': !card.name }">
    <header class="tb-ticket-card__head">
      <span class="tb-ticket-card__no">#{{ card.number }}</span>
      <span class="tb-ticket-card__name">{{ card.name || "Available" }}</span>
      <button v-if="removable" type="button" class="tb-icon-btn" :aria-label="`Remove ticket ${card.number}`" @click="$emit('remove', card)">
        <b-icon icon="close" size="is-small"></b-icon>
      </button>
    </header>
    <div class="tb-ticket-card__body">
      <TicketGrid :card="card.card" :marked="marked" />
    </div>
  </article>
</template>

<script>
  import TicketGrid from "./TicketGrid.vue";

  /** A ticket with its number/owner header — used on both Home and Live. */
  export default {
    name: "TicketCard",
    components: { TicketGrid },
    props: {
      // A card as stored by the cloud functions: { number, name, card }.
      card: {
        type: Object,
        required: true
      },
      marked: {
        type: Array,
        default: () => []
      },
      removable: {
        type: Boolean,
        default: false
      }
    }
  };
</script>
